// Lookups owned by the Overview tab and the add form. Kept apart from queries.ts so they can evolve on their own.
import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
} from '@/lib/graphql-query-builder';

/** All departments of the active organization. */
export const buildGetBasicInfoDepartmentsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    Departments: getDepartments(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ItemId
        Title
        Key
      }
    }
  }
`;

/** CTC levels of the active organization, which stands for the country of employment. */
export const buildGetBasicInfoCtcLevelsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    CtcLevels: getCtcLevels(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ItemId
        Level
        Ranks
        CTC
      }
    }
  }
`;

/** Reporting-manager typeahead over employees, newest first, like the old `employee/basicInfos`
 * `{ CreateDate: -1 }` sort. */
export const buildGetBasicInfoManagersQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    Employees: getUserProfileDetails(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral([{ field: 'CreatedDate', direction: 'DESC' }])}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        UserId
        DisplayName
        Email
      }
    }
  }
`;
